import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import apis from '@src/apis';
import actions from '@src/redux/actions';
import { VOICE_STATUS } from '@src/constants/voiceCloning';
import { Close, Warning } from '@mui/icons-material';
import { StyledActiveVoiceDialog } from './index.style';

const WarningDialog = ({
  open,
  onClose,
  title,
  warningContent,
  onDeleteVoice,
  warningTextConfirm,
  warningTextConfirmValue,
  handleChangeVoiceData,
  showWarningContent = true,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const processDeleteVoice = async () => {
    const res = await apis.voiceCloning.deleteCloningVoice(
      warningTextConfirmValue?.id,
    );
    if (!res.status) {
      dispatch(
        actions.noti.push({ severity: 'error', message: 'deleteVoiceFailed' }),
      );
      return;
    }

    dispatch(
      actions.noti.push({ severity: 'success', message: 'deleteVoiceSuccess' }),
    );
    onDeleteVoice(warningTextConfirmValue.id);
    onClose();
  };

  const processUnactiveVoice = async () => {
    const res = await apis.voiceCloning.updateVoiceCloningVoice(
      warningTextConfirmValue?.id,
      { status: VOICE_STATUS.READY },
    );
    if (!res.status) {
      dispatch(
        actions.noti.push({
          severity: 'error',
          message: 'unactiveVoiceFailed',
        }),
      );
      return;
    }
    handleChangeVoiceData(warningTextConfirmValue?.id, {
      status: VOICE_STATUS.READY,
      subStatus: res.result.voice?.subStatus,
    });
    dispatch(
      actions.noti.push({
        severity: 'success',
        message: 'unactiveVoiceSuccess',
      }),
    );
    onClose();
  };

  const handleSelectYesBtn = async () => {
    setLoading(true);
    // Deactive voice
    if (warningTextConfirm === 'confirmUnactiveVoice') {
      await processUnactiveVoice();
    }

    if (warningTextConfirm === 'confirmDeleteVoiceText') {
      await processDeleteVoice();
    }

    setLoading(false);
  };

  return (
    <StyledActiveVoiceDialog open={open} onClose={onClose}>
      <DialogTitle classes={{ root: 'box-title' }}>
        <Typography className="title">{title}</Typography>
        <Close className="close-icon" onClick={onClose} />
      </DialogTitle>
      <DialogContent classes={{ root: 'box-content' }}>
        {showWarningContent && (
          <Box className="box-content-warning">
            <Warning className="warning-icon" />
            <Typography
              className="warning-text"
              dangerouslySetInnerHTML={{
                __html: t(warningContent),
              }}
            />
          </Box>
        )}
        <Typography
          className="content"
          dangerouslySetInnerHTML={{
            __html: t(warningTextConfirm, {
              value: warningTextConfirmValue?.name,
            }),
          }}
        />
      </DialogContent>
      <DialogActions classes={{ root: 'box-action' }}>
        <Button
          className="action-btn no-btn"
          fullWidth
          onClick={handleSelectYesBtn}
        >
          {loading ? <CircularProgress size={24} /> : t('yesValue')}
        </Button>

        <Button className="action-btn" fullWidth onClick={onClose}>
          {t('noValue')}
        </Button>
      </DialogActions>
    </StyledActiveVoiceDialog>
  );
};

export default WarningDialog;
